var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"color":"red"}},[_vm._v(" mdi-numeric-"+_vm._s(_vm.number)+"-circle ")])}
var staticRenderFns = []

export { render, staticRenderFns }